import { ApplicationState } from "@idw-types/state";
import { initialCommonState } from "./reducers/common-reducer";
import { initialErrorState } from "./reducers/error-reducer";
import { initialLanguageState } from "./reducers/language-reducer";
import { initialQueryParametersState } from "./reducers/query-parameters-reducer";
import { initialSubmissionState } from "./reducers/submission-reducer";
import { initialVerificationConfigurationState } from "./reducers/verification-configuration-reducer";
import { initialVerificationFormState } from "./reducers/verification-form-reducer";

export const initialState: ApplicationState = {
    common: initialCommonState,
    error: initialErrorState,
    language: initialLanguageState,
    queryParameters: initialQueryParametersState,
    submission: initialSubmissionState,
    verificationConfiguration: initialVerificationConfigurationState,
    verificationForm: initialVerificationFormState
};